module.exports = __webpack_public_path__ + "img/dataZero.d03d5f45.png";